import { ISettings } from './settings';

export class ICompany {
    _id                   : string;
    name                  : string;
    type                  : string;
    bannerImage           : string;
    address               : string;
    websiteUrl            : string;
    phone                 : string;
    fax                   : string;
    contactPerson         : string;
    country               : string;
    isDelete              : Boolean;
    modifiedBy            : string;
    contactPersonEmail    : string;
    bookingSubdomain      : string;
    globalSetting         : ISettings;
    whatsappApiKey        : string;
    smsUsername           : number;
    smsPassword           : string;
    smsSender             : string; 
}